
const isIOS = () => {
	const userAgent = navigator ? navigator.userAgent : ''
	return (userAgent && /(iphone|ipad|ipod)/i.test(userAgent))
}

const isAndroid = () => {
	const userAgent = navigator ? navigator.userAgent : ''
	return (userAgent && /(android)/i.test(userAgent))
}

const isReactNative = () => navigator && navigator.product === 'ReactNative'

const isMobile = isIOS() || isAndroid()

const detectMobileScreen = (height, width) => {
	const availW = Math.max(width, height)
	const availH = Math.min(width, height)
	return ((availW < 768 || availH < 500) && isMobile)
}

export {
	detectMobileScreen,
	isIOS,
	isAndroid,
	isMobile,
	isReactNative,
}
